import { render, staticRenderFns } from "./SpecialrequestEdit.vue?vue&type=template&id=bb6799c2&"
import script from "./SpecialrequestEdit.vue?vue&type=script&lang=js&"
export * from "./SpecialrequestEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports